import React from "react";
import { Link } from "react-router-dom";
import "./topbar.css";
import { Button } from "@material-ui/core";
const Topbar = () => {
  console.log(process.env.PUBLIC_URL);
  return (
    <>
      <div className="topbar">
        <img
          src={`${process.env.PUBLIC_URL}/assets/menulogo.png`}
          alt="logo parkingu"
        />
        <ul>
          <li>
            <a href="https://www.parkingpyrzowiceartlot.pl/" className="link">
              <Button className="button" color="primary">
                <p>Home</p>
              </Button>
            </a>
          </li>
          <li>
            <a
              href="https://www.parkingpyrzowiceartlot.pl/kontakt.html"
              className="link"
            >
              <Button className="button" color="primary">
                <p>Kontakt</p>
              </Button>
            </a>
          </li>
          <li>
            <a
              href="https://www.parkingpyrzowiceartlot.pl/galeria-foto.html"
              className="link"
            >
              <Button className="button" color="primary">
                <p>Galeria</p>
              </Button>
            </a>
          </li>
          <li>
            <Link to="/agent" className="link">
              <Button className="button" color="primary">
                <p>Agent</p>
              </Button>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Topbar;
